var React = require('react');

function WalletInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M22 3H2v13a5 5 0 0 0 5 5h15V7H6v2h14v2h-5a3 3 0 1 0 0 6h5v2H7a3 3 0 0 1-3-3V5h18V3Zm-2 12v-2h-5a1 1 0 1 0 0 2h5Z","clipRule":"evenodd"}));
}

WalletInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = WalletInline;

WalletInline.default = WalletInline;
